import React, { FC } from 'react';
import { SrWidget } from './SrWidget';

export interface SrWidgetMatchLineUpsProps extends React.HTMLAttributes<HTMLDivElement> {
    matchId: string;
}

export const SrWidgetMatchLineUps: FC<SrWidgetMatchLineUpsProps> = ({ matchId, ...props }) => {
    const widgetProps = { matchId: matchId, disableWidgetHeader: true };
    return <SrWidget widgetName="match.lineUps" widgetProps={widgetProps} {...props} />;
};
